import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabsserviceinpune() {



  const cardData =
  {
    keyword: ' Cabs Service in Pune',
    heading: 'Sai Trupti Cabs: Cabs Service in Pune',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable cab services in Pune, designed to make your local rides and out-station journeys smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors, comfortable seating and ample luggage space. Every trip is handled by a professional, background-verified chauffeur who ensures punctual pickup anywhere in Pune, courteous service, and safe, smooth driving throughout your journey. With transparent pricing, flexible booking options (local, one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel in Pune convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is the pride of Pune — a majestic 18th-century fort built by the Peshwas that stands as a living symbol of Maratha valor and grandeur. Its mighty stone walls, elegant arches, and ornate gates recall the era when the fort served as the heart of the Maratha Empire. The iconic Delhi Darwaza and intricate fountains inside whisper tales of royal assemblies and fierce battles. Though partially destroyed by fire, its remains still exude historic strength and charm. The evening light-and-sound show brings these stories alive under the night sky, making Shaniwar Wada a must-visit for anyone exploring Pune’s glorious past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is both an architectural marvel and a monument of national pride, built in 1892 by Sultan Aga Khan III. During India’s freedom struggle, it served as a place of internment for Mahatma Gandhi, Kasturba Gandhi, and other leaders of the Quit India Movement. The palace’s Italian arches, sprawling gardens, and memorial halls radiate peace and reflection. Inside, a museum displays rare photographs, letters, and personal belongings of Gandhi. Every step through its serene corridors connects visitors to India’s journey of sacrifice and resilience. The palace is not just a landmark — it’s a shrine of history and hope."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, perched high in the Sahyadri Ranges about 30 km from Pune, is a place where nature, adventure, and history meet. It gained fame after the heroic Battle of Sinhagad, where Tanaji Malusare fought valiantly under Chhatrapati Shivaji Maharaj’s command. The steep trek to the top rewards visitors with breathtaking valley views and cool breezes. Local stalls selling steaming pithla-bhakri and lemon juice add a rustic charm to the experience. At sunrise, clouds drift past the ramparts, bathing the fort in gold. Sinhagad isn’t just a fort — it’s the heartbeat of Maratha bravery."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill offers Pune a spiritual retreat high above the city, combining devotion and panoramic beauty. The temple complex, dedicated to Lord Shiva and Goddess Parvati, was built by the Peshwas in the 18th century. Climbing the 108 steps leading up the hill feels meditative, rewarded by sweeping views of Pune’s skyline. Early mornings fill the air with temple bells and cool breezes, while sunsets here are spectacular. The small Peshwa Museum nearby preserves relics of royal heritage. For those seeking calm, Parvati Hill is Pune’s natural and divine vantage point."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is Pune’s most beloved spiritual landmark, known for its magnificent gold-adorned idol of Lord Ganesha. Founded over a century ago, the temple draws millions of devotees every year. During Ganesh Chaturthi, it becomes the epicenter of music, lights, and devotion, uniting the entire city in celebration. The atmosphere inside radiates calm and faith, with priests performing rituals that echo through the marble halls. Beyond religion, the temple supports numerous charitable activities, embodying the spirit of compassion. Visiting Dagdusheth Ganpati fills hearts with positivity and hope."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is not only a historic monument but also a monument of peace and purpose. Built in 1892, it became an important site in India’s struggle for freedom. The palace served as a detention site for Mahatma Gandhi, whose ashes are preserved here along with those of Kasturba Gandhi. The lush lawns and tranquil environment make it a serene retreat within the city. Its architecture combines European grace with Indian simplicity. Visitors come here to honor India’s freedom heroes and experience the quiet dignity of this national treasure."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove of India’s cultural legacy, created from the personal collection of Dr. Dinkar Kelkar. The museum houses over 20,000 artifacts — from antique musical instruments and ornaments to ancient sculptures and traditional household tools. The highlight is the recreated 17th-century Wada (Maratha Mansion) that immerses visitors in the lifestyle of old Pune. Each exhibit tells a story of creativity and craftsmanship. It’s a must-visit destination for art lovers and anyone curious about India’s timeless heritage."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, located just 20 km from Pune, is the city’s favorite weekend escape. Set against green hills and shimmering waters, the dam offers a peaceful spot for picnics, cycling, and evening strolls. During monsoon, the area comes alive with waterfalls and lush greenery, creating postcard-perfect scenery. Local vendors serve spicy bhajis and steaming tea along the banks, adding to the cozy atmosphere. As the sun sets, the reflection of golden light over the water creates an unforgettable sight. Khadakwasla Dam embodies the natural charm of Pune’s outskirts."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "In Koregaon Park lies the Osho International Meditation Resort — a lush sanctuary of calm and consciousness. Spread across landscaped gardens, it attracts seekers from all over the world. The resort offers meditation sessions, wellness therapies, and holistic programs in a setting that blends Zen architecture with tropical greenery. Silence, serenity, and self-discovery form the rhythm of life here. Visitors come to rejuvenate body and mind amid artistic spaces and tranquil energy. Osho Resort captures Pune’s cosmopolitan side — modern, mindful, and deeply spiritual."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "The Pune Okayama Friendship Garden, also known as Pu La Deshpande Udyan, is a harmonious fusion of Japanese landscaping and Indian flora. Spread over 10 acres, it features flowing streams, stone bridges, manicured lawns, and flower beds arranged in serene symmetry. Inspired by Japan’s Korakuen Garden, it symbolizes friendship between Pune and Okayama City. Families come here to walk, meditate, or simply unwind amidst scenic beauty. The garden’s peaceful design and cultural symbolism make it one of Pune’s most beautiful green retreats."
  }
],



 "services": [
    {
      "name": "Cabs Service in Pune",
      "description": "Enjoy the most reliable and comfortable cabs service in Pune for all your travel needs. Whether you need a local city ride, airport transfer, or an outstation trip, our cab services ensure punctuality, comfort, and affordability. We provide a wide range of vehicles including hatchbacks, sedans, SUVs, Ertiga, and Innova with professional, polite drivers. Our 24/7 service, easy online booking, transparent pricing, and GPS-enabled cars make every journey safe, smooth, and enjoyable for families, tourists, and corporate clients."
    },
    {
      "name": "Taxi Service Pune",
      "description": "Our Taxi Service in Pune offers a dependable and efficient travel experience for local, one-way, and intercity trips. We operate round the clock, providing both AC and Non-AC options tailored to your comfort. From airport pickups to outstation journeys, our clean and well-maintained taxis are driven by courteous chauffeurs who ensure a smooth and safe ride. Enjoy transparent fares, instant online booking, and the convenience of doorstep service across Pune city and nearby destinations."
    },
    {
      "name": "Car Hire Pune",
      "description": "Hire a car in Pune for local sightseeing, business meetings, or weekend getaways with our flexible Car Hire Pune service. Choose from an extensive fleet of vehicles including sedans, SUVs, and luxury cars. We provide customized rental packages for hourly, daily, and long-term use. All cars are well-maintained, sanitized, and come with professional drivers ensuring a seamless and comfortable travel experience across Pune and Maharashtra."
    },
    {
      "name": "AC Cab Pune",
      "description": "Book an AC Cab in Pune for a cool and pleasant journey around the city or to nearby destinations. Our fleet includes top-rated vehicles equipped with powerful air conditioning, ensuring maximum comfort during hot weather. Perfect for corporate clients, family tours, or airport transfers, our AC cabs offer reliability, cleanliness, and punctual service at affordable prices."
    },
    {
      "name": "Non AC Cab Pune",
      "description": "Looking for a budget-friendly cab option? Our Non-AC Cab Pune service offers clean, comfortable rides at the lowest prices. Ideal for short trips, errands, and local commutes, these cabs come with professional drivers and punctual service. Enjoy reliable transportation without compromising safety or convenience, perfect for everyday travel in and around Pune."
    },
    {
      "name": "Luxury Cab Pune",
      "description": "Experience premium comfort with our Luxury Cab Service in Pune. Choose from high-end models like Innova Crysta, BMW, Mercedes, or Audi for weddings, corporate travel, or VIP transfers. Each car features plush interiors, AC comfort, and is driven by trained chauffeurs who ensure a luxurious, safe, and stylish travel experience across Pune and beyond."
    },
    {
      "name": "Innova Cab Pune",
      "description": "Book an Innova Cab in Pune for group or family travel with ample seating space, AC options, and professional chauffeurs. Ideal for long-distance trips, weekend getaways, and corporate outings, our Innovas are known for comfort and reliability. Get transparent pricing, doorstep pickup, and 24x7 booking assistance for a smooth travel experience."
    },
    {
      "name": "Ertiga Cab Pune",
      "description": "Our Ertiga Cab Service in Pune is perfect for small groups and families seeking a blend of comfort and affordability. The 7-seater Ertiga ensures ample space, AC comfort, and smooth travel across local and outstation routes. Whether you’re planning a short city ride or a long journey, our professional drivers ensure a safe and pleasant experience."
    },
    {
      "name": "Affordable Cab Pune",
      "description": "Enjoy the best cab rides in Pune at affordable prices with no hidden charges. Our Affordable Cab Pune service offers clean vehicles, trained drivers, and on-time pickups for local, one-way, and outstation travel. With flexible payment options, online booking, and 24-hour support, we make comfortable travel accessible to everyone."
    },
    {
      "name": "Pune One Way Cab",
      "description": "Book a Pune One Way Cab and pay only for what you travel. Ideal for travelers heading to cities like Mumbai, Lonavala, Nashik, or Kolhapur, our one-way taxis are available at competitive rates. Choose from sedans, SUVs, or luxury vehicles, and enjoy safe, punctual, and convenient intercity travel with experienced drivers."
    },
    {
      "name": "Drop Cab Service Pune",
      "description": "Our Drop Cab Service in Pune offers reliable one-way trips to any destination in Maharashtra. Whether it’s a drop to the airport, railway station, or another city, we provide prompt pickups and clean, comfortable cars. Enjoy transparent pricing, professional drivers, and hassle-free booking for your one-way travel needs."
    },
    {
      "name": "Corporate Cab Pune",
      "description": "We specialize in Corporate Cab Services in Pune for daily office commutes, business meetings, and client transfers. Our fleet includes premium AC cars with professional chauffeurs who maintain punctuality and comfort. We offer customizable packages, monthly billing, and 24/7 support for corporate clients to ensure seamless travel management."
    },
    {
      "name": "Wedding Cab Pune",
      "description": "Make your wedding travel luxurious and convenient with our Wedding Cab Pune service. From premium vehicles for the bride and groom to comfortable transportation for guests, we provide well-decorated, clean, and reliable cars. Our professional chauffeurs ensure timely pickups and safe travel to and from venues, making every wedding event smooth and stylish."
    },
    {
      "name": "Online Cab Booking Pune",
      "description": "Book your cab in Pune instantly with our easy-to-use online booking system. Choose your car type, set your route, and confirm your ride in seconds. Our Online Cab Booking Pune platform offers secure payments, instant confirmations, and round-the-clock customer support for a convenient and reliable booking experience."
    },
    {
      "name": "Best Cab Service Pune",
      "description": "Choose the Best Cab Service in Pune for safe, reliable, and comfortable travel. We offer a complete range of taxi options for local, outstation, and airport transfers. Our professional drivers, sanitized vehicles, 24x7 support, and transparent fares make us the top-rated choice for thousands of travelers across Pune and Maharashtra."
    }
  ],
  "tableData": [
    ["Cabs Service in Pune", "Taxi Service Pune"],
    ["Car Hire Pune", "AC Cab Pune"],
    ["Non AC Cab Pune", "Luxury Cab Pune"],
    ["Innova Cab Pune", "Ertiga Cab Pune"],
    ["Affordable Cab Pune", "Pune One Way Cab"],
    ["Drop Cab Service Pune", "Corporate Cab Pune"],
    ["Wedding Cab Pune", "Online Cab Booking Pune"],
    ["Best Cab Service Pune", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Cabs Service in Pune",
    "WhyChoosedescription": "Sai Trupti Cabs  provides reliable and comfortable cab services across Pune — ideal for city travel, airport transfers, corporate trips, and leisure rides."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Enjoy clear, affordable pricing with no hidden charges, making your Pune cab travel cost-effective and stress-free."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, or luxury cars depending on your group size, luggage, and comfort preferences."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and trained drivers are familiar with Pune’s routes, ensuring safe, smooth, and timely rides."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer convenient pickups and drop-offs anywhere in Pune — including city locations, airports, railway stations, and residential areas."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All our cabs are regularly serviced, sanitized, and maintained to provide a comfortable and reliable travel experience."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel planning, and any queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]































  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  provide cab services in Pune?',
    answer: 'Yes, Sai Trupti Cabs  offers reliable and affordable cab services throughout Pune for local travel, airport transfers, corporate travel, and outstation trips.',
  },
  {
    question: 'How can I book a cab service in Pune with Sai Trupti Cabs?',
    answer: 'You can book a cab in Pune easily through our website, mobile app, or by contacting our 24×7 customer support team for quick assistance and confirmation.',
  },
  {
    question: 'What types of cabs are available in Pune?',
    answer: 'We provide a wide range of vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, Urbania, and Tempo Travellers to suit solo travelers, families, and groups.',
  },
  {
    question: 'Are the drivers experienced for cab services in Pune?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in navigating Pune city traffic, ensuring a safe and comfortable ride.',
  },
  {
    question: 'Can I hire a cab in Pune for corporate, airport, or family travel?',
    answer: 'Certainly. Our cab services in Pune cater to corporate clients, airport transfers, family trips, sightseeing, and outstation travel.',
  },
  {
    question: 'Is the cab service in Pune available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services in Pune, allowing you to book rides anytime according to your schedule and convenience.',
  },
  {
    question: 'What are the cab fares in Pune?',
    answer: 'Cab fares in Pune start from approximately ₹200-₹400 for local short trips, and for longer trips, fares depend on the vehicle type, distance, and travel time.',
  },
  {
    question: 'What payment methods are accepted for cab bookings in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for secure and hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict safety and hygiene protocols to ensure a safe and comfortable journey.',
  },
  {
    question: 'Is customer support available during cab rides in Pune?',
    answer: 'Yes, our dedicated 24×7 customer support team is available to assist you before, during, and after your cab journey in Pune.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Kiran More',
    feedback: 'I regularly use Sai Trupti Cabs in Pune. The service is reliable, cars are clean, and drivers are punctual and courteous.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Shah',
    feedback: 'Excellent cab service in Pune! Booking was easy through the app, and the ride was smooth and comfortable.',
    rating: 5,
  },
];
















































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Cabs Service in Pune",
  "image": "https://saitrupticabs.com/assets/images/cab-service-pune.jpg",
  "description": "Book reliable cab services in Pune with Sai Trupti Cabs. Choose AC, Non-AC, luxury rides, Innova or Ertiga for one-way trips, drop services, corporate travel, weddings, or daily commutes. Affordable online booking available 24x7.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "500",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/cabs-service-pune"
  }
};




  return (
    <div>
      <Helmet>
  <title>Cabs Service in Pune | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book reliable cab services in Pune with Sai Trupti Cabs. Choose AC, Non-AC, luxury rides, Innova or Ertiga for one-way trips, drop services, corporate travel, weddings, or daily commutes. Affordable online booking available 24x7." 
  />
  <meta 
    name="keywords" 
    content="Cabs Service in Pune, Taxi Service Pune, Car Hire Pune, AC Cab Pune, Non AC Cab Pune, Luxury Cab Pune, Innova Cab Pune, Ertiga Cab Pune, Affordable Cab Pune, Pune One Way Cab, Drop Cab Service Pune, Corporate Cab Pune, Wedding Cab Pune, Online Cab Booking Pune, Best Cab Service Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/newimages/2.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabsserviceinpune;